export default __webpack_public_path__ + "static/media/group372.11892786.svg";